import { createAsyncThunk } from '@reduxjs/toolkit';
import InvoiceApi from '@infrastructure/invoice-api';
import { getErrorPayload } from '@application/common/helpers/api-helper';
import { addSuccessNotification } from '../common/notificationSlice';
export const getAllInvoiceAsync = createAsyncThunk('Invoice/GetAll', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await InvoiceApi.getAllInvoice(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllInvoiceStatusAsync = createAsyncThunk('Invoice/GetAllInvoiceStatus', async (_, { rejectWithValue }) => {
    try {
        const response = await InvoiceApi.getAllInvoiceStatus();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getInvoiceByIdAsync = createAsyncThunk('Invoice/GetById', async (invoiceId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await InvoiceApi.getInvoiceById(invoiceId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getWorkOrdersListWithClientAsync = createAsyncThunk('debtor/GetContactPersonsByDebitorIdAsync', async (workOrderNumber, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await InvoiceApi.getWorkOrdersListWithClientAsync(workOrderNumber);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getIncrementedInvoiceNumberAsync = createAsyncThunk('Invoice/GetIncrementedInvoiceNumber', async (_, { rejectWithValue }) => {
    try {
        const response = await InvoiceApi.getIncrementedInvoiceNumber();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const CreateInvoiceAsync = createAsyncThunk('Invoice/Create', async (createdInvoice, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.createInvoice(createdInvoice);
        dispatch(addSuccessNotification('Facturen succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const UpdateInvoiceAsync = createAsyncThunk('Invoice/Update', async (Updatedinvoice, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.updateInvoice(Updatedinvoice);
        dispatch(addSuccessNotification('Facturen succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createInvoiceAmountAsync = createAsyncThunk('Invoice/CreateInvoiceAmount', async (invoiceAmount, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.createInvoiceAmount(invoiceAmount);
        dispatch(addSuccessNotification('Facturen bedrag succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllInvoiceAmountsAsync = createAsyncThunk('Invoice/GetAllInvoiceAmounts', async (invoiceId, { rejectWithValue }) => {
    try {
        const response = await InvoiceApi.getAllInvoiceAmounts(invoiceId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateInvoiceAmountAsync = createAsyncThunk('Invoice/UpdateInvoiceAmount', async (invoice, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.updateInvoiceAmount(invoice);
        dispatch(addSuccessNotification('Facturen Bedrag succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getInvoiceAmountByIdAsync = createAsyncThunk('Invoice/GetInvoiceAmountById', async (invoiceId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await InvoiceApi.getInvoiceAmountById(invoiceId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteInvoiceAmountAsync = createAsyncThunk(`Invoice/DeleteInvoiceAmount`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.deleteInvoiceAmount(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteInvoiceByIdAsync = createAsyncThunk(`Invoice/Delete`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.deleteInvoiceById(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateInvoiceAmountPositionAsync = createAsyncThunk('Invoice/updateInvoiceAmountPosition', async (invoice, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.updateInvoiceAmountPosition(invoice);
        dispatch(addSuccessNotification('Facturen Bedrag succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateBulkInvoiceAmountAsync = createAsyncThunk('Invoice/UpdateBulkInvoiceAmount', async (invoice, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.updateBulkInvoiceAmount(invoice);
        dispatch(addSuccessNotification('Record succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateCostEstimatePdfAsync = createAsyncThunk('Invoice/GenerateCostEstimatePdf', async (costEstimatePdfData, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.generateCostEstimatePdf(costEstimatePdfData);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateInvoicePdfAsync = createAsyncThunk(`Invoice/GenerateInvoicePdf`, async (invoicePdfData, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.generateInvoicePdf(invoicePdfData);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateCostEstimatePdfAsAttachmentAsync = createAsyncThunk('Invoice/generateCostEstimatePdfAsAttachment', async (costEstimatePdfData, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.generateCostEstimatePdfAsAttachment(costEstimatePdfData);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateInvoicePdfAsAttachmentAsync = createAsyncThunk(`Invoice/GenerateInvoicePdfAsAttachment`, async (invoicePdfData, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await InvoiceApi.generateInvoicePdfAsAttachment(invoicePdfData);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
